import urlJoin from 'proper-url-join';

// can only be used within the next js application
// not bonnet/plugins or bonnet/ctx-middleware
export default function getWebPathname(...parts) {
    return urlJoin(process.env.BASE_PATH, ...parts);
}
